import { useTherapist } from "../../../context/useTherapist";
import { useSubscription } from "../../subscription";

/**
 * Whether the Plus onboarding modal is pending for the current therapist.
 *
 * One rule, one place: the layout uses it to hold the training tour and the MFA
 * modal back, and the modal uses it to decide whether to mount at all. Two
 * copies of this predicate would eventually disagree and stack two first-run
 * surfaces on top of each other.
 *
 * Evaluated on every app entry rather than at registration: plan assignment
 * only happens at sign-up, so a therapist upgraded to Plus later still has the
 * flag false and is offered the flow the next time they come in.
 */
export const useOnboardingEligibility = (): boolean => {
    const { therapist, loadingTherapist } = useTherapist();
    const { isPremium } = useSubscription();

    return (
        !loadingTherapist &&
        therapist != null &&
        isPremium &&
        therapist.has_completed_onboarding === false
    );
};
